import {ethers} from 'ethers'

export default async function getNativeBalance(address: string): Promise<ethers.BigNumber> {
    const provider = new ethers.providers.Web3Provider((window as any).ethereum);
    const _balance = await provider.getBalance(address);
    return _balance
}